export const RESTING_CAMERA_Z = 5;
export const ACTIVE_CAMERA_Z = 6.5; // Camera distance when wheel is spinning/animating (not ready/complete)
export const MAX_CAMERA_Z = 7; // Maximum camera distance at max speed
export const RESTING_ORBIT_RADIUS = 2.75;
export const ACTIVE_ORBIT_RADIUS = 3.75; // Orbit radius when wheel is spinning/animating (not ready/complete)
export const MAX_ORBIT_RADIUS = 4; // Maximum orbit radius at max speed
export const MAX_SPIN_SPEED = 1.0; // Maximum spin speed to normalize against (spins per second)
export const COIN_RADIUS = 0.8;
export const ORBIT_VIEWPORT_MARGIN = 0.25;
export const OVERLAY_PLANE_GROUP_Z = -12; // Z position of overlay plane group (behind coin's exit position)
